// 🔑 Формуємо ключ локації для перевірки дублікатів
const locKey = (loc) => [ loc?.state_id, loc?.city_id, loc?.zip_code ].join('|');

/**
 * Витягує з payload (loads.locations_delivery / loads.locations_pickup)
 * список нових унікальних локацій, яких ще немає в commonLocations.
 *
 * @param {Object} payload         - об'єкт extractGPT (містить loads)
 * @param {Array<Object>} commonLocations - поточний масив локацій (state.tripDialog.location)
 * @returns {Array<Object>} Масив локацій, які треба додати в commonLocations
 */
export function locationsToAddFromExtract(payload, commonLocations = []) {
	// Нормалізуємо loads до масиву
	const loadsList = Array.isArray(payload?.loads) ? payload.loads : [ payload?.loads ].filter(Boolean);

	// Ключі існуючих локацій, щоб не додавати дублікати
	const existing = new Set((commonLocations || []).map(locKey));
	// Додатковий Set для унікальності в межах поточного проходу
	const planned = new Set();

	const result = [];

	/*
	 * Кандидат на додавання:
	 * - пропускаємо null / undefined
	 * - пропускаємо, якщо вже є в existing або вже заплановано (planned)
	 * - нормалізуємо поля і додаємо в result
	 */
	const queue = (loc, fallback) => {
		if (!loc) return; // ⛔ порожні ігноруємо
		const key = locKey(loc);
		if (existing.has(key) || planned.has(key)) return; // ⛔ дублі ігноруємо

		result.push({
			state_id: loc.state_id ?? null,
			city_id: loc.city_id ?? null,
			zip_code: loc.zip_code ?? null,
			// city/state беремо з loc або з елемента (fallback) pickup/delivery
			city: loc.city ?? fallback?.city ?? null,
			state: loc.state ?? fallback?.start ?? null,
		});

		planned.add(key);
	};

	// Обходимо всі loads і їх pickup/delivery
	loadsList.forEach(ld => {
		(ld?.locations_delivery || []).forEach(item => queue(item?.location, item));
		(ld?.locations_pickup || []).forEach(item => queue(item?.location, item));
	});

	return result;
}
